import { render, staticRenderFns } from "./ZGOverview.vue?vue&type=template&id=232d2ca8&scoped=true&"
import script from "./ZGOverview.vue?vue&type=script&lang=js&"
export * from "./ZGOverview.vue?vue&type=script&lang=js&"
import style0 from "./ZGOverview.vue?vue&type=style&index=0&id=232d2ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232d2ca8",
  null
  
)

export default component.exports